// src/components/common/Badge.jsx
export const Badge = ({ children, variant = "default" }) => {
  const variants = {
    default: { backgroundColor: "#f1f5f9", color: "#475569" },
    success: { backgroundColor: "#dcfce7", color: "#166534" },
    warning: { backgroundColor: "#fef3c7", color: "#92400e" },
    danger: { backgroundColor: "#fee2e2", color: "#991b1b" },
    info: { backgroundColor: "#dbeafe", color: "#1e40af" }
  };

  const style = {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 12px",
    borderRadius: "16px",
    fontSize: "13px",
    fontWeight: "600",
    ...variants[variant]
  };

  return <span style={style}>{children}</span>;
};